import React from 'react';
import { motion } from 'framer-motion';

const BackingSlide = () => {
  const investors = [
    { name: 'Y Combinator', src: '/assets/logos/ycombinator.png' },
    { name: '186 Ventures', src: '/assets/logos/186ventures.png' },
    { name: 'General Catalyst', src: '/logos/generalcatalyst.png' },
    { name: 'Heuristic Capital', src: '/assets/logos/heuristiccapital.png' },
    { name: 'Rebel Fund', src: '/assets/logos/rebelfund.png' },
  ];

  const team = [
    { name: 'Google', src: '/assets/logos/google.png' },
    { name: 'Brex', src: '/assets/logos/brex.png' },
    { name: 'Berkeley', src: '/assets/logos/berkeley.png' },
    { name: 'HF', src: '/assets/logos/henryford.png' },
    { name: 'Ascension', src: '/assets/logos/ascension.png' },
  ];

  return (
    <div className="h-full w-full bg-slate-50 flex flex-col items-center justify-center p-12 relative overflow-hidden">
        {/* Abstract Background - Matches other slides */}
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-blue-100/40 rounded-full blur-[80px] -translate-y-1/2 translate-x-1/2" />
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-purple-100/40 rounded-full blur-[80px] translate-y-1/2 -translate-x-1/2" />
        
        {/* Dot Pattern Overlay */}
        <div className="absolute inset-0 bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:32px_32px] opacity-60" />

        {/* Funding Badge - Moved to Top Right */}
        <div className="absolute top-8 right-8 md:top-12 md:right-12 z-20">
            <div className="px-5 py-2 bg-white/80 backdrop-blur-sm border border-blue-100 rounded-full text-blue-600 font-bold text-lg shadow-sm flex items-center gap-2 whitespace-nowrap">
                <span className="text-slate-500 font-medium text-sm">Funding:</span> $4.4M
            </div>
        </div>

        <div className="relative z-10 max-w-[1400px] w-full flex flex-col items-center justify-center h-full gap-8 md:gap-12">
            
            {/* Header Section */}
            <motion.div 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="text-center space-y-4 md:space-y-6 mt-4"
            >
                <div className="flex flex-row items-center justify-center gap-6 md:gap-8">
                    <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold text-slate-900 tracking-tight">
                        Built & backed by the best.
                    </h2>
                </div>
                <p className="text-lg md:text-xl text-slate-500 font-medium max-w-3xl mx-auto">
                    Backed by the best institutional investors in the world ({'<'}1% acceptance rate)
                </p>
            </motion.div>

            {/* Investors Grid */}
            <div className="w-full flex-shrink-0">
                <div className="flex flex-wrap items-center justify-center gap-6 md:gap-8 lg:gap-10">
                    {investors.map((logo, idx) => (
                        <motion.div 
                            key={idx}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: idx * 0.1 + 0.2 }}
                            whileHover={{ y: -5, shadow: "0 20px 25px -5px rgb(0 0 0 / 0.1)" }}
                            className="bg-white p-6 md:p-8 rounded-3xl shadow-sm border border-slate-100 w-[140px] h-[140px] md:w-[180px] md:h-[180px] lg:w-[200px] lg:h-[200px] flex flex-col items-center justify-center gap-4 transition-all duration-300"
                        >
                            <div className="w-full h-full flex items-center justify-center p-2">
                                 <img 
                                    src={logo.src} 
                                    alt={logo.name} 
                                    className={`max-w-full max-h-full object-contain transition-all duration-500 hover:scale-105 ${
                                        logo.name === 'General Catalyst' ? 'scale-110' : ''
                                    }`}
                                />
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>

            {/* Team Section */}
            <motion.div 
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ delay: 0.6, duration: 0.8 }}
                className="w-full text-center space-y-8 md:space-y-12"
            >
                <p className="text-xl md:text-2xl font-semibold text-slate-700">
                    Built by an incredible team of AI experts and Chief Medical Officers
                </p>
                
                {/* Single Row of Logos */}
                <div className="flex flex-wrap items-center justify-center gap-10 md:gap-16 lg:gap-20 px-4 w-full">
                    {team.map((logo, idx) => (
                        <motion.img 
                            key={idx}
                            src={logo.src} 
                            alt={logo.name}
                            initial={{ opacity: 0, y: 10 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.8 + idx * 0.1 }}
                            className={`${
                                logo.name === 'Berkeley' 
                                    ? 'h-10 md:h-14 lg:h-16' 
                                    : 'h-6 md:h-10 lg:h-12'
                            } w-auto object-contain transition-all duration-300 hover:scale-110`}
                        />
                    ))}
                </div>
            </motion.div>

        </div>
    </div>
  );
};

export default BackingSlide;























